import $ from 'jquery';
import _ from 'lodash';
import { Model }            from 'backbone';
import BasePropertyView from 'BasePropertyView.js';
import constants        from 'Constants.js';
import contentTemplate  from 'dashboard/settings/user-position-details-view.ejs';
import RestService from 'RestService';
import NotificationService from 'NotificationService';
import eventBus from 'EventBus.js';
import undoService from 'UndoService.js'
import SelectItemModalView from 'common-views/SelectItemModalView.js';
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView.js";
import textConstants from 'TextConstants';
import dashboardService from 'DashboardService';
import util from 'util/Util';
import listService from 'ListService.js';
import Spinner from 'spin/spin';

class UserPositionDetailsView extends BasePropertyView {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;
        
        this.Spinner = new Spinner();

        this.events = {
            'keyup input': 'updateButtonActions',
            'change input[type=text],textarea': 'updateTextInputs',
            'change input[type=checkbox]': 'updateCheckboxesInputs',
            'blur textarea, input[type=text]'   : 'lostFocus',
            'focus textarea, input[type=text]'   : 'getFocus',
            'click input[name=applyChanges]': 'applyChanges',
            'click input[name=selectUser]': 'showUserName',
            'click input[name=removeUser]': 'removeUser',
            'click input[name=cancel]': 'cancelChanges',
            'click input[name=deletePosition]': 'deletePosition',
            'click #goToSettings': 'goToSettings',
            'click #goToAccountSettings': 'goToSettings',
            'click #goToPositionInformation': 'goToPositionInformation'
        };


        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    showUserName(ev){
        this.Spinner.spin($(constants.CONTENT_ID).get(0));
        setTimeout(() => {
            RestService.browseAllUsers().then((userData)=> {
                let users=[];
                if (userData.AllUsers && userData.AllUsers.User) {
                    users = userData.AllUsers.User instanceof Array
                        ? userData.AllUsers.User
                        : [userData.AllUsers.User];
                }

                let items = [];
                users.forEach(user => {                            
                    if (user['@type'] === 'user'){
                        items.push({ 
                            id: user['@id'],
                            label: user['@caption'],
                            listType: 'user',
                            items: user
                        });
                    }
                });

                const selectView = new SelectItemModalView({model: new Model({items:items, subtitle:'Select User'}), spinner: this.Spinner});

            selectView.render().then(selectedItemInModal => {
                if(selectedItemInModal) {
                let userChosen = {
                    '@id': selectedItemInModal.id,
                    '@caption': selectedItemInModal.label,
                    '@type': "user"
                };
                let currentModel=this.model.get('updatedUserPositionDetails');
                currentModel.MembersXML= {
                    "Members":{
                    "User":{
                        "@id":userChosen["@id"],
                        "@caption":userChosen["@caption"],
                        "@type":userChosen["@type"]
                    }
                    }
                };
                this.model.set('updatedUserPositionDetails',currentModel,{silent:true});
                this.model.set('addedUser', userChosen,{silent:true});
                this.model.set('hasChanges',true,{silent:true});
                this.render();
                this.updateButtonActions();
                }
            });
            }).catch((error)=> {
                console.log('Error', error);
                if (error.CODE === '75') {
                    NotificationService.error('An error has ocurred. The maximum number of users with offline form filling enabled has been reached.')
                }
            });
        }, 10);
    }

    deletePosition(ev) {      
      dashboardService.deleteUserPosition();
    }

    convertUserToXML(user){
      if($.isEmptyObject(user)){
       return "&lt;Members/&gt;"
      }
        let xmlString =
            `<Members>${String.fromCharCode(10)}` +
            `  <User type="${user["@type"]}" id="${user["@id"]}" />${String.fromCharCode(10)}` +
            `</Members>`;
        return xmlString.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    removeUser(ev) {
      let currentPositionDetails=this.model.get('updatedUserPositionDetails');
      this.model.set('removedUser',currentPositionDetails.MembersXML.Members.User,{silent:true});
      currentPositionDetails.MembersXML.Members.User={};
      this.model.set('updatedUserPositionDetails',currentPositionDetails,{silent:true});
      this.model.set('hasChanges',true,{silent:true});
      this.render();
      this.updateButtonActions();
    }

    cancelChanges() {
      this.model.set('updatedUserPositionDetails', $.extend(true,{}, this.model.get('userPositionDetails')), {silent: true});
      this.model.set('removedUser', {},{silent:true});
      this.model.set('addedUser', {},{silent:true});
      this.model.set('hasChanges',false,{silent:true});
      this.render();
    }


    updateButtonActions() {
        $("#noChangesSection").addClass('hide');
        $("#changesSection").removeClass('hide');
    }

    updateTextInputs(ev) {
        let prop = ev.target.name;
        let value = ev.target.value;
        let userDetails = this.model.get('updatedUserPositionDetails');
        userDetails[prop] = value;
        this.model.set('updatedUserPositionDetails', userDetails, {silent: true});
        this.model.set('hasChanges',true,{silent:true});
        this.updateButtonActions();
    }

    updateCheckboxesInputs(ev) {
        let prop = ev.target.name;
        let propVal  = ev.currentTarget.checked;
        let userDetails = this.model.get('updatedUserPositionDetails');
        userDetails[prop] = propVal? 'true': 'false';
        this.model.set('updatedUserPositionDetails', userDetails, {silent: true});
        this.model.set('hasChanges',true,{silent:true});
        this.updateButtonActions();
    }

    updateTreeview(){
        eventBus.trigger(constants.UPDATE_USER_POSITION_TREEVIEW,this.model.get('userPositionId'));
    }

    applyChanges(){
        let self = this;
        let updatedModel = this.model.get('updatedUserPositionDetails');
        let userPositionId = this.model.get('userPositionId');
        const removedUser = this.model.get('removedUser');
        const addedUser = this.model.get('addedUser');
        const currentMember =  updatedModel.MembersXML ? updatedModel.MembersXML.Members.User : updatedModel.MembersXML;

        console.log("Actual Model",updatedModel);
        const updatedPosition = {
            positionId: userPositionId,
            name: updatedModel.Name,
            description: updatedModel.Description,
            isActive: updatedModel.IsActive,
            members:this.convertUserToXML(currentMember)
        };

        const originalModel = this.model.get('userPositionDetails');

        const originalPosition = {
            positionId: userPositionId,
            name: originalModel.Name,
            description: originalModel.Description,
            isActive: originalModel.IsActive,
            members:originalModel.MembersXML ? this.convertUserToXML(originalModel.MembersXML.Members.User) : this.convertUserToXML(originalModel.MembersXML)
        };



        undoService.add({
            undo: () => {
                // by inverting the remove and add parameter
                // we add the removed and remove the added (undo)
                this.persistData(originalPosition, userPositionId);
            },
            redo: () => {
                this.persistData(updatedPosition, userPositionId);
            }
        }, textConstants.UNDO_UPDATE_USER_GROUP);

        this.persistData(updatedPosition,userPositionId);
        util.setUndoRedoAccess();
    }

    persistData(data, userPositionId){
        this.updateUserPosition(data).then(()=>{
            if (listService.activeDashboardTab === 'settings'){
                this.refreshUserData(userPositionId);
            }
        }).catch((error)=> {
            this.handleUpdateError(error);
        });
    }

    handleUpdateError(error){
        console.log('Error', error);
        if (error.CODE === '75') {
            NotificationService.error('An error has ocurred. The maximum number of users with offline form filling enabled has been reached.')
        }
    }

    updateUserPosition(position){
      return RestService.updateUserPosition(position);
    }

    refreshUserData(userPositionId){
      RestService.getUserPositionDetails(userPositionId).then((userPositionDetails)=> {

        if($.isEmptyObject(userPositionDetails.MembersXML)){
          userPositionDetails.MembersXML={
            "Members":{
              "User":{}
            }
          }
        }


        this.model.set('dashboardTitle', 'User-Position - ' + userPositionDetails.Name);
        this.model.set('userPositionId', userPositionId);
        this.model.set('userPositionDetails', userPositionDetails);
        this.model.set('updatedUserPositionDetails', Object.assign({}, userPositionDetails));


            this.render();
            this.updateTreeview();
        }).catch((error)=> {
            console.log('Error', error);
            if (error.CODE === '75') {
                NotificationService.error('An error has ocurred. The maximum number of users with offline form filling enabled has been reached.')
            }
        });
    }

    displayOrHideUserRemovalButton(){
      if($.isEmptyObject(this.model.get('updatedUserPositionDetails').MembersXML.Members.User)){
        $("#removeUser").prop('disabled',true);
      }
      else{
        $("#removeUser").prop('disabled',false);
      }
    }

    render() {
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.displayOrHideUserRemovalButton();

        this.delegateEvents();
        this.$el.css('cursor', 'default');

        return this;
    }

    refresh(){
        this.cancelChanges();
    }

    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    refresh(){
        if(this.model.get('hasChanges')){            
            let simpleModal=new SimpleConfirmModalView({
                model:new Model({subtitle:`User Position Details - ${this.model.get("userPositionDetails").Name}`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                    eventBus.trigger(constants.EV_REFRESH_POSITION_DETAILS,this.model.get('userPositionId'))
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
            eventBus.trigger(constants.EV_REFRESH_POSITION_DETAILS,this.model.get('userPositionId'))
        }  
    }

    goToAccountSettings(e) {
        e.preventDefault();
        e.stopPropagation();
        $('div.document-heading > a[data-target="#well_1"]').click();
    }

    goToPositionInformation(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div#well_2 a[data-itemid="positionsGroup"]').click();        
    }
}

export default UserPositionDetailsView;

